import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import InsightsPage from './pages/InsightsPage';
import ArticlePage from './pages/ArticlePage';
import LocationsIndex from './pages/LocationsIndex';
import LocationPage from './pages/LocationPage';
import { Toaster } from './components/ui/toaster';
import WelderOfDayTape from './components/WelderOfDayTape';
import ScrollToTop from './components/ScrollToTop';
import { orgJsonLd } from './components/SEO';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(orgJsonLd())}</script>
      </Helmet>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <WelderOfDayTape />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:id" element={<ArticlePage />} />
            <Route path="/welding-electrodes-in" element={<LocationsIndex />} />
            <Route path="/welding-electrodes-in/:citySlug" element={<LocationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
